import React from 'react';

const KeyInfoCoverage = ({ ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M29.202 22.432a.59.59 0 00.394-.153.479.479 0 00.174-.372V9.754a.478.478 0 00-.174-.372.585.585 0 00-.394-.153H2.798a.582.582 0 00-.394.153.479.479 0 00-.175.372v12.153a.48.48 0 00.175.372.587.587 0 00.394.153h2.928V15.83c0-.32.11-.59.33-.808.217-.219.487-.328.807-.328.291 0 .547.11.765.328.22.218.328.488.328.808v6.602h3.716v-3.585c0-.32.11-.59.328-.809.22-.218.488-.328.808-.328.291 0 .547.11.765.328.22.218.328.49.328.81v3.584h3.716V15.83c0-.32.11-.59.328-.808.22-.219.488-.328.81-.328.29 0 .546.11.763.328.22.218.33.488.33.808v6.602h3.714v-3.585c0-.32.11-.59.328-.809.22-.218.474-.328.765-.328.32 0 .591.11.81.328.217.218.327.49.327.81v3.584h3.41zm-26.404 2.23c-.758 0-1.413-.27-1.967-.81s-.83-1.188-.83-1.945V9.754c0-.758.276-1.406.83-1.946C1.385 7.27 2.041 7 2.798 7h26.404c.758 0 1.413.27 1.967.808.554.54.831 1.188.831 1.946v12.153c0 .757-.277 1.406-.83 1.945-.555.54-1.21.81-1.968.81H2.798z"
      ></path>
    </svg>
  );
};

export default KeyInfoCoverage;
